// axiosInstance.js
import axios from "axios";

const axiosInstance = axios.create({
  baseURL: "https://thejobship.onrender.com/",
});

export default axiosInstance;

export const weburl = "https://thejobship.onrender.com/";
export const shopurl = "https://admin.thejobship.com/";
export const mainurl = "https://admin.thejobship.com/";
export const fronturl = "https://thejobship.com/";

export const keyLogin = process.env.REACT_APP_LOGIN_KEY;
